import { render, staticRenderFns } from "./CropCard.vue?vue&type=template&id=05dc6964&scoped=true&"
import script from "./CropCard.vue?vue&type=script&lang=js&"
export * from "./CropCard.vue?vue&type=script&lang=js&"
import style0 from "./CropCard.vue?vue&type=style&index=0&id=05dc6964&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05dc6964",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSlideXTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VCard,VCardSubtitle,VCardText,VCardTitle,VDialog,VImg,VSlideXTransition})
